import useGetApi from '../useGetApi';

export interface HealthCheckResult {
  status: 'healthy' | 'unhealthy';
  timestamp: string;
  databaseStatus: 'healthy' | 'unhealthy';
  databaseResponseTime?: number;
}

export interface HealthCheckResponse {
  current: HealthCheckResult | null;
  history: HealthCheckResult[];
  metrics: {
    uptimeLastDay: number | null;
    totalChecks: number;
  };
}

export const useSystemStatus = (refreshInterval = 60000) => {
  return useGetApi<HealthCheckResponse>({
    endpoint: 'health/public-status',
    options: {
      refetchInterval: refreshInterval,
      refetchOnWindowFocus: true,
    },
  });
};
